import { c as _c } from "react/compiler-runtime";
import { Badge } from '@common/components';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
interface SearchContentsCardProps {
  imageSrc?: string;
  title?: string;
  content?: string;
  daysAgo?: string;
  link?: string;
  tags?: string[];
}
export const SearchContentsCard = t0 => {
  const $ = _c(21);
  const {
    imageSrc,
    title,
    content,
    daysAgo,
    link: t1,
    tags
  } = t0;
  const link = t1 === undefined ? "#" : t1;
  let t2;
  if ($[0] !== title) {
    t2 = title ? <h3 className="line-clamp-1 break-all font-600 text-Gray-black typo-body3 mobile-tablet:line-clamp-2 mobile-tablet:typo-body4">{title}</h3> : null;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== content) {
    t3 = content ? <p className="line-clamp-2 break-all font-400 text-Gray-600 typo-body4 mobile-tablet:typo-caption1">{content}</p> : null;
    $[2] = content;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== tags) {
    t4 = tags && tags.length > 0 ? <div className="flex flex-wrap gap-4 break-keep">{tags.slice(0, 3).map(_temp)}</div> : null;
    $[4] = tags;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== daysAgo) {
    t5 = daysAgo ? <p className="font-400 text-Gray-550 typo-caption1">{daysAgo}</p> : null;
    $[6] = daysAgo;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <div className="flex min-w-0 flex-1 flex-col gap-8 mobile-tablet:gap-12">{t2}{t3}{t4}{t5}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== imageSrc) {
    t7 = imageSrc ? <Image alt="thumbnail" className="aspect-square shrink-0 rounded-small border-1 border-Gray-100 object-cover mobile-tablet:size-68 mobile-tablet:self-center" height={96} src={imageSrc} width={96} /> : null;
    $[13] = imageSrc;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className="flex items-start gap-24">{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== link || $[19] !== t8) {
    t9 = <CustomLink href={link} className="flex flex-col gap-8 rounded-medium border border-Gray-100 bg-Gray-white px-24 py-20 transition-colors hover:bg-Gray-25 mobile-tablet:gap-12 mobile-tablet:rounded-none mobile-tablet:border-0">{t8}</CustomLink>;
    $[18] = link;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
function _temp(tagName) {
  return <Badge key={tagName}>{tagName}</Badge>;
}